<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'theme-color',
      content: '#317EFB',
    },
  ],
});
</script>
<template>
  <v-app>
    <VitePwaManifest />
    <NuxtLoadingIndicator color="#313A68" :height="3" />
    <NuxtLayout />
  </v-app>
</template>
